import { TreeType } from '../../markdown.types';
import { buildTreeFromTags } from './buildTreeFromTags/buildTreeFromTags';
import { IGenerateTreeOptions } from './generateTree.types';

export const generateTree = ({ text, positionToTag }: IGenerateTreeOptions): TreeType => {
  const tagsPositions = Object.keys(positionToTag);

  if (tagsPositions.length === 0) {
    return [
      {
        tag: 'text',
        content: text,
      },
    ];
  }

  return buildTreeFromTags({
    text,
    positionToTag,
    startContent: 0,
    endContent: text.length,
    tagsPositions,
  });
};
